// Firefox имеет давние баги печати PDF из iframe (Bug 1618621, 1618553,
// 1945551). Надёжный обход: рендерим PDF в canvas через pdfjs-dist, потом
// печатаем PNG как обычную картинку через iframe.

export async function printPdfSilent(base64) {
    const pdfjsLib = await import('pdfjs-dist');
    if (!pdfjsLib.GlobalWorkerOptions.workerPort) {
        pdfjsLib.GlobalWorkerOptions.workerPort = new Worker(
            new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url),
            { type: 'module' }
        );
    }
    const binary = atob(base64);
    const len = binary.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) bytes[i] = binary.charCodeAt(i);

    const loadingTask = pdfjsLib.getDocument({ data: bytes });
    const pdf = await loadingTask.promise;

    const dataUrls = [];
    for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
        const page = await pdf.getPage(pageNum);
        const viewport = page.getViewport({ scale: 3 });
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = viewport.width;
        canvas.height = viewport.height;
        await page.render({ canvasContext: ctx, viewport }).promise;
        dataUrls.push(canvas.toDataURL('image/png'));
    }

    return new Promise((resolve, reject) => {
        try {
            const iframe = document.createElement('iframe');
            iframe.style.position = 'fixed';
            iframe.style.top = '0';
            iframe.style.left = '0';
            iframe.style.width = '1px';
            iframe.style.height = '1px';
            iframe.style.opacity = '0';
            iframe.style.pointerEvents = 'none';
            iframe.style.zIndex = '-1';
            document.body.appendChild(iframe);

            const cleanup = () => {
                try { document.body.removeChild(iframe); } catch (_) {}
                resolve();
            };

            iframe.onload = () => {
                try {
                    const imgs = Array.from(iframe.contentDocument.images);
                    const waitFor = imgs
                        .filter(img => !img.complete)
                        .map(img => new Promise(r => {
                            img.onload = () => r();
                            img.onerror = () => r();
                        }));
                    Promise.all(waitFor).then(() => {
                        try { iframe.contentWindow.focus(); } catch (_) {}
                        iframe.contentWindow.print();
                        setTimeout(cleanup, 1000);
                    });
                } catch (e) {
                    cleanup();
                    reject(e);
                }
            };
            iframe.onerror = () => {
                cleanup();
                reject(new Error('iframe load failed'));
            };

            iframe.srcdoc = `<!DOCTYPE html><html><head><meta charset="utf-8"><style>
                @page { margin: 0; }
                html, body { margin: 0; padding: 0; }
                img { display: block; max-width: 100%; max-height: 100vh; width: auto; height: auto; object-fit: contain; page-break-after: always; }
                img:last-child { page-break-after: auto; }
            </style></head><body>${dataUrls.map(u => `<img src="${u}">`).join('')}</body></html>`;
        } catch (e) {
            reject(e);
        }
    });
}

export function downloadPdf(base64, filename) {
    const binary = atob(base64);
    const len = binary.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) bytes[i] = binary.charCodeAt(i);
    const blob = new Blob([bytes], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    setTimeout(() => {
        try { document.body.removeChild(a); } catch (_) {}
        URL.revokeObjectURL(url);
    }, 100);
}
